export class DatosBasicos { 
    primerNombre: string;
    segundoNombre: string;
    primerApellido: string;
    segundoApellido: string;
    edad: Number;
    genero: string;
    fechaNacimiento: string;
    corregidos?: boolean;
    
    static instance() {
      return new this();
    }
  }